import React from "react";
import {
  Menu,
} from "semantic-ui-react";
import './Explorerbar.css'
import { home_lables } from "../../data/home_labels";
import { getDatabases } from "../../features/tableData/visualSlice";
import { useSelector } from "react-redux";

const Homebar = () => {
  // const [activeItemIdx, setActiveItemIdx] = useState(-1);

  // const handleItemClick = (index) => {
  //   if(activeItemIdx === index){
  //     setActiveItemIdx(-1);
  //   }
  //   else{
  //     setActiveItemIdx(index);
  //   }
  // };

  const databases = useSelector(getDatabases);

  return (
          <>
            <Menu.Item>
              Home
            </Menu.Item>
            <Menu.Item>
              <div><p>{home_lables[databases[0].name]}</p></div>
            </Menu.Item>
            {/* <Menu.Item className="no_padding_accordian">
            <Accordion fluid>  
                <Accordion.Title
                  active={activeItemIdx === 0}
                  onClick={() => handleItemClick(0)}
                >
                  <a href="https://www.youtube.com/watch?v=ML_Qw0-HXes" target="_blank" rel="noreferrer"> Data Explainer</a>
                </Accordion.Title>

                <Accordion.Title
                  active={activeItemIdx === 1}
                  onClick={() => handleItemClick(1)}
                >
                  <a href="https://www.youtube.com/watch?v=8HmbjASuvMI" target="_blank" rel="noreferrer"> Sample Easy Queries</a>
                </Accordion.Title>

                <Accordion.Title
                  active={activeItemIdx === 2}
                  onClick={() => handleItemClick(2)}
                >
                  <a href="https://www.youtube.com/watch?v=VhtqbxDFj7w" target="_blank" rel="noreferrer"> Sample Advanced Queries</a>
                </Accordion.Title>

  
            </Accordion>
            </Menu.Item> */}
          </>
  );
};

export default Homebar;